import React from "react";
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import { message, Spin } from 'antd';
export function request (config) {
  // setLoading(true);
  return new Promise((resolve, reject) => {
    axios(config).then(res => {
      // setLoading(false);
      if(res.status === 200){
        const { data, headers } = res;
        if(data.code === "200") {
          if(config?.params?.needHeadersDate === true) {
            let resData = {...data.data, serverDate:headers.date};
            resolve(resData)
          } else {
            resolve(data.data)
          }
        } else {
          message.error(data.message)
          reject(data.message)
        }
      }
    }).catch(err => {
      // setLoading(false);
      reject(err)
    });
  }) 
}
export const NoticeClassfiyList = [
  { text: "政府采购", classfiy: '1', types:'1',},
  { text: "建设工程", classfiy: '2', types:'1',},
  { text: "国资国企", classfiy: '3', types:'1',},
  { text: "采购公示", classfiy: '4', types:'2', pt:'1'},
  { text: "直采优选", classfiy: '5', types:'4',},
  { text: "询价寻源", classfiy: '6', types:'3', pt: '3'},
  { text: "其它要素", classfiy: '7', types:'1',},
  { text: "其它公告", classfiy: '8', types:'5', pt: '5'},
  { text: "合同公示", classfiy: '9', types:'9', pt: '1'},
  { text: "采购意向公示", classfiy: '10', types:'10'},
  { text: "重大项目", classfiy: '11', types:'11'},
];

export const InvoiceOpenTypeList = [
  {value: '1', label:'电子普票'},
  {value: '2', label:'电子专票'},
]

export const TypesSlect = [
  {id:'2', text: "招采 (交易)公告", classfiy: '1', types:'1', },
  {id:'3', text: "中标(成交)与结果公告", classfiy: '6,7,8,9,10', types:'1',},
  {id:'4', text: "变更澄清公告", classfiy: '2,3,4,5' ,types:'1',},
  {id:'5', text: "采购公示", classfiy: '1', types:'2',},
  {id:'6', text: "征求意见", classfiy: '2', types:'2',},
  {id:'7', text: "市场调研", classfiy: '4', types:'2',},
  {id:'8', text: "询价寻源", classfiy: '3', types:'3',},
  {id:'9', text: "直采优选", classfiy: '1', types:'4',},
  // {id:'10', text: "其它要素1111", classfiy: '7', types:'1',},
  {id:'12', text: "其它公告", classfiy: '5', types:'5'},
  {id:'13', text: "新签", classfiy: '9', types:'9', pt: '1'},
  {id:'14', text: "续签", classfiy: '12', types:'9', pt: '2'},
  {id:'15', text: "变更", classfiy: '13', types:'9', pt: '3'},
  {id:'16', text: "其他", classfiy: '17', types:'9', pt: '4'},
  {id:'17', text: "合同公示", classfiy: '18', types:'9'},
  {id:'18', text: "采购意向公示", classfiy: '19', types:'10'},
  {id:'19', text: "重大项目", classfiy: '19', types:'19'},
];

// 公示类型
export  const PublicType = {
  1:'采购公示',
  2:'征求意见',
  3:'询价寻源',
  4:'市场调研',
  5:'其它公告',
};

// 公告类型
export  const NoticeType = [
  '采购公告',
  '变更公告',
  '中止公告',
  '澄清公告',
  '重新采购',
  '其它公告',
  '结果公告',
  '候选公示',
  '招标失败',
  '终止公告',
  '合同公示',
  '重大项目'
];
// 公告分类
// export const NoticeClassfiy = [
//   '政府采购',
//   '建设工程',
//   '国资国企',
//   '采购公示',
//   '直采优选',
//   '询价寻源',
//   '其它要素',
// ];

// todo 生产环境要修改此地址
// export const dsAiUrl = 'http://192.168.77.20:8081';
export const dsAiUrl = 'https://dsai.aipuret.cn';

export const loadNetcaJs = (cb) => {
  if (window.NetcaPKI !== undefined) {
    console.log('已加载window.NetcaPKI', window.NetcaPKI);
    cb !== undefined && cb();
    return
  }
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = "/portal-notice/static/ckeditor/netca/netcawebsocket.js";
  document.body.appendChild(script);
  if (script.readyState) {
    //IE下
    script.onreadystatechange = function () {
      if (script.readyState === 'complete' || script.readyState === 'loaded') {
        script.onreadystatechange = null;
        cb !== undefined && cb();
      }
    };
  } else {
    script.onload = function () {
      cb !== undefined && cb();
    };
  }
}

export const frontendPaging = function (pageSize = 10, pageIndex = 1, data = []) {
  let pageData = [];
  let total = data.length || 0;
  let pages = pageSize > 0 ? Math.ceil(total / pageSize) : 0;//向上取整
  let start = (pageSize * pageIndex) - pageSize; //从第几条开发
  let end = pageSize * pageIndex; //到第几条结束
  end = end > total ? total : end;
  for (let i = start; i < end; i++) {
    pageData.push(data[i]);
  }
  return { pageSize, pageIndex, pageData, total, pages }

}

export function setLoading(isloading) {
  let dom = document.getElementById('loading')
  if (isloading) {
    if(!dom){
      dom = document.createElement('div');
      dom.setAttribute('id', 'loading');
      document.getElementById('root').appendChild(dom);
    }
    const root = createRoot(dom);
    root.render(<Spin fullScreen spinning={true} size={'large'} style={{textAlign: 'center'}} />)
  } else {
    const root = createRoot(dom);
    root.render(<Spin fullscreen spinning={false} size={'large'} style={{textAlign: 'center'}} />)
  }
}
